import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { TonConnectButton, useTonConnectUI } from '@tonconnect/ui-react';
import { useNavigate } from 'react-router-dom';
import { v1 } from 'uuid';
import { FaCheck } from 'react-icons/fa';
import { MainTitle } from '../../components/main-title';
import { Select } from '../../components/ui/select';
import { Button } from '../../components/ui/button';
// import { Profile } from '../../components/profile'
import TokenPriceHook from '../../hooks/token-price-hook';
import { useTonAddress } from '../../hooks/useTonAdress';
import { useTextTelegram } from '../../hooks/useTextTelegram';
import { useBgTelegram } from '../../hooks/useBgTelegram';
import { useBg2Telegram } from '../../hooks/useBg2Telegram';
import { fixAmount } from '../../utils/fix-amount';
import { Coupon } from '../../logic/coupon';
import { StorageWallet } from '../../logic/storage';
import s from './create-check-page.module.scss';
const DEFAULT_VALUES = {
    typeCheck: 'Personal',
    amount: '0',
    password: '',
    oneActivation: '0',
    amountActivation: '0',
    confirmPassword: ''
};
export const CreateCheckPage = ({ balance, isTestnet, isTg }) => {
    const navigate = useNavigate();
    const [values, setValues] = useState(DEFAULT_VALUES);
    const [errors, setErrors] = useState({});
    const [isDeploying, setIsDeploying] = useState(false);
    const [isAgreed, setIsAgreed] = useState(false);
    const [tonConnectUI, setOptions] = useTonConnectUI();
    const telegramText = useTextTelegram(isTg);
    const telegramBG = useBgTelegram(isTg);
    const telegramBG2 = useBg2Telegram(isTg);
    const rawAddress = useTonAddress(false);
    const options = [
        {
            value: 'Personal',
            label: 'Personal'
        },
        {
            value: 'Multicheck',
            label: 'Multicheck'
        }
    ];
    const handleSelectChange = (value) => {
        setValues({ ...values, typeCheck: value });
    };
    if (!balance) {
        return null;
    }
    const deploy = () => {
        setIsDeploying(true);
        const coupon = new Coupon(tonConnectUI, isTestnet);
        const storageWallet = new StorageWallet();
        const couponKey = v1();
        if (!rawAddress) {
            return;
        }
        coupon
            .deployOne(values.password, values.amount)
            .then((couponResult) => {
            const dataToSave = {
                // sum: values.amount,
                id: couponKey,
                address: couponResult,
                typeCheck: values.typeCheck,
                userAddress: rawAddress,
                date: Date.now()
            };
            if (couponResult) {
                storageWallet.save(couponKey, dataToSave);
                navigate('/');
            }
            setValues(DEFAULT_VALUES);
        })
            .catch((error) => {
            console.error('Error deploying:', error);
        })
            .finally(() => {
            setIsDeploying(false);
        });
    };
    const deployMultiCheck = () => {
        setIsDeploying(true);
        const multi = new Coupon(tonConnectUI, isTestnet);
        const storageWallet = new StorageWallet();
        const multiKey = v1();
        multi
            .deployMulti(values.password, values.oneActivation, values.amountActivation, rawAddress)
            .then((multiResult) => {
            const dataToSave = {
                // oneActivation: values.oneActivation,
                amountActivation: values.amountActivation,
                address: multiResult,
                id: multiKey,
                typeCheck: values.typeCheck,
                userAddress: rawAddress,
                date: Date.now()
            };
            if (multiResult) {
                storageWallet.save(multiKey, dataToSave);
                navigate('/');
            }
            setValues(DEFAULT_VALUES);
        })
            .catch((error) => {
            console.error('Error deploying:', error);
        })
            .finally(() => {
            setIsDeploying(false);
        });
    };
    const onSubmit = (e) => {
        e.preventDefault();
        const validationErrors = {};
        if (!values.typeCheck) {
            validationErrors.typeCheck = 'Type of check is required';
        }
        else if (values.typeCheck === 'Personal') {
            const validateAmount = (amount) => {
                const parsedAmount = parseFloat(amount);
                return (/^\d+(\.\d+)?$/.test(amount)
                    && parsedAmount >= 0.00001
                    && parsedAmount <= 100000.99999);
            };
            if (!validateAmount(values.amount)) {
                validationErrors.amount = 'Invalid amount';
            }
        }
        else if (values.typeCheck === 'Multicheck') {
            const validateActivationAmount = (amount) => {
                const parsedAmount = parseFloat(amount);
                return (/^\d+(\.\d+)?$/.test(amount)
                    && parsedAmount >= 0.00001
                    && parsedAmount <= 1500000);
            };
            if (!validateActivationAmount(values.oneActivation)) {
                validationErrors.oneActivation = 'Invalid amount';
            }
            if (!/^\d+$/.test(values.amountActivation)) {
                validationErrors.amountActivation = 'Amount must be an integer';
            }
            else if (!validateActivationAmount(values.amountActivation)) {
                validationErrors.amountActivation = 'Invalid amount';
            }
        }
        if (values.password.length < 8) {
            validationErrors.password = 'Password must be at least 8 characters long';
        }
        else if (!/[a-zA-Z]/.test(values.password)) {
            validationErrors.password = 'Password must include English letters';
        }
        else if (/[а-яА-Я]/.test(values.password)) {
            validationErrors.password = 'Password must not contain Russian characters';
        }
        if (values.password !== values.confirmPassword) {
            validationErrors.confirmPassword = 'Passwords do not match';
        }
        if (values.typeCheck === 'Multicheck') {
            if (!isAgreed) {
                validationErrors.agreement = 'You must agree to the terms for Multicheck';
            }
        }
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
        }
        else if (values.typeCheck === 'Personal') {
            deploy();
        }
        else if (values.typeCheck === 'Multicheck') {
            deployMultiCheck();
        }
    };
    return (_jsxs("section", { children: [_jsxs("div", { className: s.headerForm, children: [_jsx(MainTitle, { title: "Create check", isTg: isTg }), _jsx(TonConnectButton, {})] }), _jsxs("form", { onSubmit: onSubmit, className: s.form, children: [_jsxs("div", { className: s.formBlock, children: [_jsx("label", { className: s.formLabel, style: telegramText, children: "Choose the type of check" }), _jsx(Select, { options: options, value: values.typeCheck, onChange: handleSelectChange, isTg: isTg }), errors.typeCheck && _jsx("div", { className: s.error, children: errors.typeCheck })] }), values.typeCheck === 'Personal' && (_jsxs("div", { className: s.formBlock, children: [_jsx("label", { className: s.formLabel, style: telegramText, children: "Send the amount of the receipt in TON" }), _jsx("input", { type: "string", name: "amount", value: values.amount, onChange: e => setValues({ ...values, amount: e.target.value }), placeholder: "min. 0.00001 TON", className: s.formInput, style: telegramBG2 }), errors.amount && _jsx("div", { className: s.error, children: errors.amount }), _jsxs("div", { className: s.formSubtext, style: telegramText, children: ["balance: ", _jsxs("span", { children: [fixAmount(balance ?? '0'), " TON (", balance ? (_jsx(TokenPriceHook, { tokenAmount: Number(fixAmount(balance)) })) : (0), ")"] })] })] })), values.typeCheck === 'Multicheck' && (_jsxs("div", { className: s.formBlock, children: [_jsx("label", { className: s.formLabel, style: telegramText, children: "Amount of one activation in TON" }), _jsx("input", { type: "string", name: "oneActivation", value: values.oneActivation, onChange: e => setValues({ ...values, oneActivation: e.target.value }), className: s.formInput, style: telegramBG2 }), errors.oneActivation && (_jsx("div", { className: s.error, children: errors.oneActivation }))] })), values.typeCheck === 'Multicheck' && (_jsxs("div", { className: s.formBlock, children: [_jsx("label", { className: s.formLabel, style: telegramText, children: "Number of activations" }), _jsx("input", { type: "string", name: "activationAmount", value: values.amountActivation, onChange: e => setValues({ ...values, amountActivation: e.target.value }), className: s.formInput, style: telegramBG2 }), errors.amountActivation && (_jsx("div", { className: s.error, children: errors.amountActivation }))] })), _jsxs("div", { className: s.formBlock, children: [_jsx("label", { className: s.formLabel, style: telegramText, children: "Set a password" }), _jsx("input", { type: "password", name: "password", value: values.password, onChange: e => setValues({ ...values, password: e.target.value }), className: s.formInput, style: telegramBG2 }), errors.password && _jsx("div", { className: s.error, children: errors.password })] }), _jsxs("div", { className: s.formBlock, children: [_jsx("label", { className: s.formLabel, style: telegramText, children: "Confirm Password" }), _jsx("input", { type: "password", name: "confirmPassword", value: values.confirmPassword, onChange: e => setValues({ ...values, confirmPassword: e.target.value }), className: s.formInput, style: telegramBG2 }), errors.confirmPassword && (_jsx("div", { className: s.error, children: errors.confirmPassword }))] }), values.typeCheck === 'Multicheck' && (_jsxs("div", { className: s.checkboxContainer, children: [_jsxs("label", { className: s.checkboxLabel, style: telegramText, children: [_jsx("input", { type: "checkbox", checked: isAgreed, onChange: () => setIsAgreed(!isAgreed), className: s.checkboxInput, style: telegramBG2 }), _jsx("div", { className: `${s.customCheckbox} ${isAgreed ? 'checked' : 'unchecked'}`, children: isAgreed ? (_jsx(FaCheck, { className: s.checkboxIcon, color: "#000", size: 19 })) : null }), "I agree to the terms"] }), _jsx("div", { className: `${s.alert} ${s.multicheckAlert}`, children: "Once you create a coupon, you won't be able to remove it without the specified password." })] })), errors.agreement && _jsx("div", { children: errors.agreement }), _jsx(Button, { type: "submit", variant: "primary-button", disabled: isDeploying || (values.typeCheck === 'Multicheck' && !isAgreed), isTg: isTg, children: isDeploying ? 'Creating...' : 'Create a check' })] })] }));
};
